import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { AuthService } from './../../../services/auth.service';

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss']
})
export class EmailVerificationComponent implements OnInit {

  success: boolean = false;
  faTimesCircle=faTimesCircle;


  constructor(
    private route: ActivatedRoute,
    private authService:AuthService,
    private router: Router) {
debugger;
      let isSucces = this.route.snapshot.queryParams.isSuccess == null ? this.route.snapshot.params.isSuccess : this.route.snapshot.queryParams.isSuccess;

      if(isSucces!=null){
        if(isSucces == "False" || isSucces == "false" || isSucces == false)
        this.success = false;
        else if(isSucces == "True" || isSucces == "true" || isSucces == true)
        this.success = true;
        // this.success=isSucces;
      }

     }

  ngOnInit() {
  }

  showLogin(){
    this.router.navigate(['/home']);
  }

}
